import styled from '@emotion/styled';

import { customPalette } from '../../../styles/theme';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background-color: ${customPalette.accent.main};
  color: ${customPalette.accent.white};
  position: sticky;
  top: 0;
  width: 100%;
  height: 120px;
  z-index: 1003;
`;

export const HamburgerIcon = styled.div`
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
`;

export const StyledLogo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
`;

export const LogoText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AppTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${customPalette.accent.white};
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${customPalette.accent.white};
`;

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 72px;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &.center-avatar {
    justify-content: space-between;
  }

  &.center-close-icon {
    justify-content: center;
  }
`;

export const BPNumber = styled.span`
  font-size: 12px;
  color: ${customPalette.accent.white};
  line-height: 1;
`;

export const BPListContainer = styled.div`
  position: absolute;
  top: 120px;
  right: 0;
  width: 100%;
  background-color: ${customPalette.accent.main};
  z-index: 1000;
  height: 100vh;
`;

export const CloseIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: ${customPalette.blue.main};
  cursor: pointer;
`;
